import { HttpErrorResponse, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { SubUrlsEnum } from '../enums/sub-urls.enum';
import { IMessage } from '../interfaces/messaging.interface';
import { messages } from './messaging';

export const mockMessagingRes: any = (request: HttpRequest<any>): Observable<HttpResponse<any> | HttpErrorResponse> => {
    // GET ALL MESSAGE
    if (request.method === 'GET' && request.url.endsWith(SubUrlsEnum.MESSAGES)) {
        for (let i: number = 0; i < 500; i++) {
            messages.push(messages[1]);
        }
        const response: any = {
            status: 200,
            body: { messages },
        };
        return of(new HttpResponse(response));
    }
    // MARK AS VIEWED
    if (request.method === 'POST' && request.url.endsWith(SubUrlsEnum.MESSAGE_VIEWED)) {
        const message: IMessage = {
            ...messages.find((msg: IMessage) => msg.id === +request.body.message_id),
            viewed: true,
        };
        const response: any = {
            status: 200,
            body: { message },
        };
        return of(new HttpResponse(response));
    }
    // ARCHIVED
    if (request.method === 'POST' && request.url.endsWith(SubUrlsEnum.MESSAGE_ARCHIVED)) {
        const message: IMessage = messages.find((msg: IMessage) => msg.id === +request.body.message_id);
        const response: any = {
            status: 200,
            body: { message },
        };
        return of(new HttpResponse(response));
    }
    // SEND NEW MESSAGE
    if (request.method === 'POST' && request.url.endsWith(SubUrlsEnum.MESSAGE)) {
        const response: any = {
            status: 200,
            body: request.body,
        };
        return of(new HttpResponse(response));
    }

    return of(new HttpResponse());
};
